export type KoreanLeadingSchoolType = 'LEADING_SCHOOL' | 'KOREAN_CULTURE_SPECIALIZED_SCHOOL'

export interface IKoreanLeadingSchool {
  leadingSchoolId: number
  type: KoreanLeadingSchoolType | string
  regionCode: number
  schoolNameUz: string
  schoolNameRu: string
  schoolNameKo: string
}

export type KoreanLeadingSchoolPayload = {
  type: KoreanLeadingSchoolType
  regionCode: number
  schoolNameUz: string
  schoolNameRu: string
  schoolNameKo: string
}

const isEnvelope = (raw: unknown): raw is { success: boolean; data: unknown } =>
  !!raw && typeof raw === 'object' && 'success' in raw && 'data' in raw

export function normalizeKoreanLeadingSchoolsList(raw: unknown): IKoreanLeadingSchool[] {
  if (Array.isArray(raw)) {
    return raw as IKoreanLeadingSchool[]
  }
  if (isEnvelope(raw) && Array.isArray(raw.data)) {
    return raw.data as IKoreanLeadingSchool[]
  }
  return []
}
